import PropTypes from 'prop-types';
import React from 'react';
import BoxComponent from './BoxComponent';
import StripComponent from './StripComponent';

export default class extends React.Component {
    static displayName = 'MultipleLayoutComponent';

    static propTypes = {
        layout: PropTypes.number.isRequired,
        dir: PropTypes.string,
        settingsActions: PropTypes.object
    };

    static defaultProps = {
        dir: 'ltr'
    };

    render() {
        const { dir, settingsActions } = this.props;
        const Wrapper = this._getWrapper();
        return Wrapper ? (
                <Wrapper dir={dir} settingsActions={settingsActions}>{this.props.children}</Wrapper>
            ) : null;
    }

    _getWrapper = () => {
        let { layout } = this.props;
        let content = null;

        switch (layout) {
            case 0:
                content = BoxComponent;
                break;
            case 1:
                content = StripComponent;
                break;
            case 2:
                break;
        }

        return content;
    };
}
